import { FC } from 'react';

import DisplayCard from 'src/components/Card/DisplayCard';
import { Flex } from 'src/components/Flex';
interface TotalAmounts {
    totalNetAmount: number;
    totalVatAmount: number;
    totalCreditAmount: number;
    usersCurrency: string;
}

export const TotalAmounts: FC<TotalAmounts> = ({
    totalCreditAmount,
    totalNetAmount,
    totalVatAmount,
    usersCurrency,
}) => {
    return (
        <Flex gap="19px">
            <DisplayCard
                label="Total Net Amount"
                value={`${usersCurrency}${totalNetAmount.toFixed(2)}`}
            />
            <DisplayCard
                label="Total Vat Amount"
                value={`${usersCurrency}${totalVatAmount.toFixed(2)}`}
            />
            <DisplayCard
                label="Total Credit Amount"
                value={`${usersCurrency}${totalCreditAmount.toFixed(2)}`}
            />
        </Flex>
    );
};
